import { useMemo } from "react";

import Sentry from "@similarweb/sentry-logger";

import { REVEALED_CONTACT_EMPTY_DATA } from "../constants/revealed-contact-mock-data";
import getRevealedContactMockItem from "../helpers/getRevealedContactMockItem";
import type { ContactSearchEntry } from "../types/common";
import type { RevealedContactDto } from "../types/dto";
import { isRevealedContactSearchEntryType } from "../utils/type-guards";

function useGetPrivateDataOrEmpty(rowData: ContactSearchEntry): RevealedContactDto {
    return useMemo(() => {
        if (isRevealedContactSearchEntryType(rowData)) {
            if (!rowData.privateData) {
                Sentry.warning("Contact revealed but privateData is undefined (ContactDetailsCell)");

                return REVEALED_CONTACT_EMPTY_DATA;
            }

            return rowData.privateData;
        }

        return getRevealedContactMockItem(
            rowData.hasValidEmails,
            rowData.hasDirectPhoneNumbers,
            rowData.hasMobilePhoneNumbers,
        );
    }, [rowData]);
}

export default useGetPrivateDataOrEmpty;
